import axios from 'axios';

export const authService = {
    /** Sessions */
    createSessionService: (body) => axios.post(`/clinical/sessions`, body, { auth: true }),

    getSessionsService: (params) => axios.get(`/clinical/sessions`, { auth: true, params: { ...params } }),

    getSessionByIdService: (id) => axios.get(`/clinical/sessions/${id}`, { auth: true }),

    resumeSessionService: (id) => axios.patch(`/clinical/sessions/${id}/resume`, {}, { auth: true }),

    pauseSessionService: (id) => axios.patch(`/clinical/sessions/${id}/pause`, {}, { auth: true }),

    endSessionService: (id) => axios.patch(`/clinical/sessions/${id}/complete`, {}, { auth: true }),

    saveSessionTargetOptionService: (body) => axios.patch(`/clinical/data`, body, { auth: true }),

    deleteDurationLogService: (tSummaryId, trialId) =>
        axios.delete(`/clinical/data/summary/${tSummaryId}/trials/${trialId}`, { auth: true }),

    refreshSessionService: (sessionId) => axios.patch(`/clinical/sessions/${sessionId}/refresh`, null, { auth: true }),

    editSessionGoalsService: (id, body) => axios.patch(`/clinical/sessions/${id}/goals`, body, { auth: true }),

    editSessionTimelineService: (id, body) => axios.patch(`/clinical/sessions/${id}/timeline`, body, { auth: true }),

    getSessionCorrectionsService: (id) => axios.get(`/clinical/sessions/${id}/corrections`, { auth: true }),

    /** Manual session data entry */
    getManualSessionApptsService: (params) => axios.get(`/clinical/sessions/manual/appts`, { auth: true, params: { ...params } }),

    saveManualSessionService: (body) => axios.put(`/clinical/sessions/manual`, body, { auth: true }),

    /** End */
};
